/* Instrumentation Microsoft Clarity — Essential Glow Design.
   Aucun effet visuel, aucune donnée personnelle : uniquement des tags et des
   événements nommés, pour pouvoir filtrer les enregistrements dans Clarity. */
(function () {
  'use strict';

  var cfg = window.EGD_CLARITY || {};
  var file = [];

  function api() {
    return typeof window.clarity === 'function' ? window.clarity : null;
  }

  function envoyer(args) {
    var c = api();
    if (c) {
      try { c.apply(null, args); } catch (e) {}
    } else if (file.length < 100) {
      file.push(args);
    }
  }

  // Clarity est injecté par l'app embed : il peut arriver après ce script.
  var essais = 0;
  var attente = setInterval(function () {
    var c = api();
    if (c) {
      clearInterval(attente);
      while (file.length) {
        try { c.apply(null, file.shift()); } catch (e) {}
      }
    } else if (++essais > 60) {
      clearInterval(attente);
    }
  }, 500);

  function tag(cle, valeur) {
    if (valeur === null || valeur === undefined || valeur === '') return;
    envoyer(['set', cle, String(valeur).slice(0, 200)]);
  }

  var deja = {};
  function evenement(nom) {
    if (deja[nom]) return;
    deja[nom] = true;
    envoyer(['event', nom]);
  }
  function evenementRepetable(nom) {
    envoyer(['event', nom]);
  }

  /* ---------- Tags de segmentation ---------- */

  function memoriser(cle, valeur) {
    try {
      if (valeur) sessionStorage.setItem(cle, valeur);
      return valeur || sessionStorage.getItem(cle);
    } catch (e) {
      return valeur;
    }
  }

  var params = new URLSearchParams(location.search);
  var crea = memoriser('egd_crea', params.get('utm_content'));
  var source = memoriser('egd_source', params.get('utm_source'));

  tag('egd_page', cfg.page);
  tag('egd_gabarit', cfg.gabarit);
  tag('egd_produit', cfg.produit);
  tag('egd_prix', cfg.prix);
  tag('egd_creative', crea);
  tag('egd_source', source);
  tag('egd_appareil', window.innerWidth < 750 ? 'mobile' : 'bureau');


  /* ---------- Masquage de sécurité ----------
     Filet indépendant du réglage de masquage du tableau de bord Clarity :
     tout champ pouvant contenir une donnée personnelle est marqué explicitement.
     Clarity n'enregistre pas le paiement Shopify, donc aucune donnée bancaire
     n'entre jamais dans son périmètre. */

  function masquerChampsSensibles(racine) {
    var selecteur = [
      'input[type="email"]',
      'input[type="tel"]',
      'input[type="password"]',
      'textarea',
      'input[autocomplete="name"]',
      'input[autocomplete="given-name"]',
      'input[autocomplete="family-name"]',
      'input[autocomplete="email"]',
      'input[autocomplete*="address"]',
      'input[autocomplete="tel"]',
      'input[autocomplete*="cc-"]',
      'input[name*="[email]"]',
      'input[name*="[Nom]"]',
      'input[name*="[name]"]'
    ].join(',');
    try {
      var champs = (racine || document).querySelectorAll(selecteur);
      for (var i = 0; i < champs.length; i++) {
        champs[i].setAttribute('data-clarity-mask', 'true');
      }
    } catch (e) {}
  }

  masquerChampsSensibles(document);
  // Les formulaires peuvent être injectés plus tard (panier, pop-ins d'app).
  if ('MutationObserver' in window) {
    new MutationObserver(function () { masquerChampsSensibles(document); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ---------- Outils ---------- */

  function surVue(element, rappel, seuil) {
    if (!element || !('IntersectionObserver' in window)) return;
    var obs = new IntersectionObserver(function (entrees) {
      for (var i = 0; i < entrees.length; i++) {
        if (entrees[i].isIntersecting) {
          obs.disconnect();
          rappel();
          return;
        }
      }
    }, { threshold: seuil || 0.35 });
    obs.observe(element);
  }

  function auClic(selecteur, rappel) {
    document.addEventListener('click', function (e) {
      var cible = e.target && e.target.closest ? e.target.closest(selecteur) : null;
      if (cible) rappel(cible);
    }, true);
  }

  var t0 = Date.now();
  function secondes() {
    return Math.round((Date.now() - t0) / 1000);
  }

  /* ---------- Fiche produit ---------- */

  if (cfg.page === 'product') {
    var bouton = document.querySelector('product-form form[action*="/cart/add"] [name="add"]');
    var ctaVu = false;

    surVue(bouton, function () {
      ctaVu = true;
      var t = secondes();
      tag('egd_cta_vu_en_s', t);
      // Trois paliers : lisibles directement comme filtres dans Clarity.
      if (t <= 5) evenement('pf_cta_vu_moins_5s');
      else if (t <= 15) evenement('pf_cta_vu_5_15s');
      else evenement('pf_cta_vu_plus_15s');
    }, 0.5);

    // La ligne « 22 pages · PDF à télécharger · aucun objet expédié ».
    surVue(document.querySelector('.egd-benefits__proof'), function () {
      evenement('pf_mention_pdf_vue');
    });

    surVue(document.querySelector('.egd-trustrow'), function () {
      evenement('pf_reassurance_vue');
    });

    surVue(document.querySelector('[data-egd-bump2]'), function () {
      evenement('pf_bump_vu');
    });

    auClic('product-form form[action*="/cart/add"] [name="add"]', function () {
      tag('egd_ajout_panier_en_s', secondes());
      evenement('pf_clic_ajout_panier');
    });

    auClic('.egd-sticky-cta [name="add"], .egd-sticky-cta button, .egd-sticky-cta a', function () {
      evenement('pf_clic_cta_collant');
    });

    var coche = document.querySelector('[data-egd-bump2-check]');
    if (coche) {
      coche.addEventListener('change', function () {
        evenementRepetable(coche.checked ? 'pf_bump_coche' : 'pf_bump_decoche');
        tag('egd_bump_final', coche.checked ? 'oui' : 'non');
      });
    }

    auClic('.product__media-item, .thumbnail-list__item', function (el) {
      var liste = [].slice.call(
        document.querySelectorAll(
          el.classList.contains('thumbnail-list__item') ? '.thumbnail-list__item' : '.product__media-item'
        )
      );
      var rang = liste.indexOf(el) + 1;
      if (rang > 0) tag('egd_image_cliquee', rang);
      evenementRepetable('pf_clic_image');
    });

    auClic('.egd-faq summary, .egd-faq details > summary', function () {
      evenementRepetable('pf_faq_ouverte');
    });

    /* Profondeur de défilement — Clarity la mesure déjà, mais en faire des
       événements permet de les utiliser comme étapes d'entonnoir. */
    var paliers = [25, 50, 75, 90];
    var atteints = {};
    function mesurerScroll() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h <= 0) return;
      var pct = Math.min(100, Math.round(((window.scrollY || window.pageYOffset) / h) * 100));
      for (var i = 0; i < paliers.length; i++) {
        var p = paliers[i];
        if (pct >= p && !atteints[p]) {
          atteints[p] = true;
          evenement('pf_scroll_' + p);
        }
      }
    }
    var tick = false;
    window.addEventListener('scroll', function () {
      if (tick) return;
      tick = true;
      requestAnimationFrame(function () { mesurerScroll(); tick = false; });
    }, { passive: true });
    mesurerScroll();

    // Sortie sans avoir jamais vu le bouton d'achat : le signal le plus net
    // d'un problème de hiérarchie en haut de page.
    window.addEventListener('pagehide', function () {
      if (!ctaVu) envoyer(['event', 'pf_sortie_sans_voir_cta']);
    });
  }

  /* ---------- Panier ---------- */

  if (cfg.page === 'cart') {
    var paye = false;
    auClic('[name="checkout"], #checkout, [href*="/checkout"]', function () {
      paye = true;
      tag('egd_paiement_en_s', secondes());
      evenement('panier_clic_paiement');
    });
    window.addEventListener('pagehide', function () {
      if (!paye) envoyer(['event', 'panier_quitte_sans_paiement']);
    });
  }
})();
